import React, {
  FC,
  useEffect,
  useState,
} from 'react';
import dynamic from 'next/dynamic';

import { IS_CLIENT_SIDE } from 'constants/constants';

import { IHeader } from '../config/declarations';

const MobileHamburgerMenu = dynamic(
  () => import('features/MobileHamburgerMenu').then((mod) => mod.MobileHamburgerMenu),
);

const MobileHamburgerWrapper: FC<IHeader> = ({ header }) => {
  const [shouldShowHamburger, setShouldShowHamburger] = useState<boolean>(false);

  useEffect(() => {
    setShouldShowHamburger(true);
  }, []);

  if (IS_CLIENT_SIDE && !shouldShowHamburger) {
    return null;
  }

  return (
    <MobileHamburgerMenu
      auth={header.authorization}
      rating={header.rating}
      nav={header.nav}
      mobileApp={header.mobileApplication}
    />
  );
};

export default MobileHamburgerWrapper;
